import React from "react";
import { motion } from "framer-motion";
import {
  Award,
  Home,
  IndianRupee,
  Sparkles,
  HeartHandshake,
  TimerReset,
} from "lucide-react";

const ITEMS = [
  {
    icon: Award,
    title: "Experienced Physiotherapist",
    desc: "Years of hands-on clinical and home-visit experience across conditions.",
  },
  {
    icon: Home,
    title: "Home Visit Available",
    desc: "Skip the commute — premium care delivered to your living room.",
  },
  {
    icon: IndianRupee,
    title: "Affordable Pricing",
    desc: "Transparent per-day pricing with no hidden charges.",
  },
  {
    icon: Sparkles,
    title: "Modern Techniques",
    desc: "Evidence-based therapy combined with the latest rehab methods.",
  },
  {
    icon: HeartHandshake,
    title: "Personalised Care",
    desc: "Every plan is tailored to your body, lifestyle and goals.",
  },
  {
    icon: TimerReset,
    title: "Fast Recovery",
    desc: "Structured plans designed to get you back to yourself, sooner.",
  },
];

export const WhyChooseUs = () => {
  return (
    <section
      data-testid="why-choose-section"
      className="py-20 sm:py-28 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-xs sm:text-sm text-brand-600 font-semibold tracking-[0.18em] uppercase">
            Why Choose Us
          </p>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
            A standard of care that <em className="not-italic bg-gradient-to-r from-brand-400 to-accent-400 bg-clip-text text-transparent">feels different</em>.
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {ITEMS.map(({ icon: Icon, title, desc }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              data-testid={`why-choose-item-${i}`}
              className="p-7 rounded-3xl bg-white border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.03)] hover:shadow-[0_20px_50px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-brand-50">
                <Icon className="w-6 h-6 text-brand-600" strokeWidth={1.5} />
              </span>
              <h3 className="mt-5 font-display text-xl font-semibold text-slate-900">
                {title}
              </h3>
              <p className="mt-2 text-slate-600 leading-relaxed text-sm">
                {desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
